import * as actionTypes from "../../actions/actionTypes";

const initState = {
  entries: [],
  searchEntriesLoading: false,
  searchEntriesError: null,
  winners: [],
  raffleDrawLoading: false,
  raffleDrawError: null,
  winnersData: [],
  winnersDataLoading: false,
  winnersDataError: null,
  savedWinners: "",
  savedError: null,
  savedLoading: false,
  totalEntries: 0,
  officialWinner: null,
  actionLoading: false,
  actionMessageSuccess: "",
  actionMessageFailed: "",
};

const raffleReducer = (state = initState, action) => {
  switch (action.type) {
    case actionTypes.SEARCH_ENTRIES_START:
      return {
        ...state,
        searchEntriesLoading: true,   
      };
    case actionTypes.SEARCH_ENTRIES_SUCCESS:
      return {
        ...state,
        searchEntriesLoading: false,
        entries: action.entries,
        total: action.total,
      };
    case actionTypes.SEARCH_ENTRIES_FAILED:
      return {
        ...state,
        searchEntriesLoading: false,
        searchEntriesError: action.err,
        total: 0,
      };
    case actionTypes.RAFFLE_DRAW_START:
      return {
        ...state,
        raffleDrawLoading: true,
      };
    case actionTypes.RAFFLE_DRAW_SUCCESS:
      return {
        ...state,
        raffleDrawLoading: false,
        winners: action.winners,
      };
    case actionTypes.RAFFLE_DRAW_FAILED:
      return {
        ...state,
        raffleDrawLoading: false,
        raffleDrawError: action.err,
      };
    case actionTypes.FETCH_WINNERS_START:
      return {
        ...state,
        winnersDataLoading: true,
      };
    case actionTypes.FETCH_WINNERS_SUCCESS:
      return {
        ...state,
        winnersDataLoading: false,
        winnersData: action.winners,
        total: action.total,
      };
    case actionTypes.FETCH_WINNERS_FAILED:
      return {
        ...state,
        total: 0,
        winnersDataLoading: false,
        winnersDataError: action.err,
      };
    case actionTypes.FILTER_WINNERS_START:
      return {
        ...state,
        winnersDataLoading: true,
      };
    case actionTypes.FILTER_WINNERS_SUCCESS:
      return {
        ...state,
        winnersDataLoading: false,
        winnersData: action.filtered,
      };
    case actionTypes.FILTER_WINNERS_FAILED:
      return {
        ...state,
        winnersDataLoading: false,
        winnersDataError: action.err,
      };
    case actionTypes.SAVE_WINNERS_START:
      return {
        ...state,
        savedLoading: true,
      };
    case actionTypes.SAVE_WINNERS_SUCCESS:
      return {
        ...state,
        savedLoading: false,
        savedWinners: action.success,
      };
    case actionTypes.SAVE_WINNERS_FAILED:
      return {
        ...state,
        savedLoading: false,
        savedError: action.err,
      };

    case actionTypes.OFFICIAL_WINNER_START:
      return {
        ...state,
        actionLoading: true,
        actionMessageFailed: null,
        actionMessageSuccess: null,
      };
    case actionTypes.OFFICIAL_WINNER_SUCCESS:
      return {
        ...state,
        actionLoading: false,
        actionMessageSuccess: action.successMessage,
      };
    case actionTypes.OFFICIAL_WINNER_FAILED:
      return {
        ...state,
        actionLoading: false,
        actionMessageFailed: action.errorMessage,
      };
    case actionTypes.RESET_ACTION_SUCCESS_MESSAGE:
      return {
        ...state,
        actionMessageSuccess: "",
      };

    case actionTypes.RESET_ENTRIES_WINNERS:
      return {
        ...state,
        entries: [],
        winners: [],
      };
    default:
      return state;
  }
};

export default raffleReducer;
